import { render, staticRenderFns } from "./single-widget.vue?vue&type=template&id=38c81003&scoped=true&"
import script from "./single-widget.vue?vue&type=script&lang=ts&"
export * from "./single-widget.vue?vue&type=script&lang=ts&"
import style0 from "./single-widget.vue?vue&type=style&index=0&id=38c81003&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c81003",
  null
  
)

export default component.exports